import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

export type HelpContactPayload = {
  /** Category card title — becomes email subject */
  category: string;
  categoryId?: string;
  message: string;
  screen?: string;
  reportedUserName?: string;
  reportedUserId?: string;
  file?: File | null;
};

export const useSendHelpContact = (
  options?: UseMutationOptions<unknown, unknown, HelpContactPayload, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: (data: HelpContactPayload) => {
      const formData = new FormData();
      formData.append("Category", data.category);
      if (data.categoryId) formData.append("CategoryId", data.categoryId);
      formData.append("Message", data.message);
      if (data.screen) formData.append("Screen", data.screen);
      if (data.reportedUserName) {
        formData.append("ReportedUserName", data.reportedUserName);
      }
      if (data.reportedUserId) {
        formData.append("ReportedUserId", data.reportedUserId);
      }
      if (data.file) {
        formData.append("File", data.file);
      }

      return axiosInstance
        .post(getAPIURL("/Email/SendHelpContact"), formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => res.data);
    },
  });
};
